import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// `vite --mode emulated` (.env.emulated): everything on the local demo-jarrell emulators. See emulated/firebase.emulated.json.
const isEmulated = import.meta.env.VITE_EMULATED === 'true';

let authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;

if (import.meta.env.DEV && !isEmulated) {
  authDomain = 'jarrell-01.firebaseapp.com';
}

const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-east4'); // Specify the region here

if (isEmulated) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9399', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8390);
  connectFunctionsEmulator(functions, '127.0.0.1', 5401);
} else if (import.meta.env.DEV) {
  // Connect to the Functions emulator when in development
  console.log('Connecting to Firebase Functions emulator on localhost:5001');
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    // console.log('Successfully connected to Firebase Functions emulator');
  } catch (error) {
    // console.warn('Failed to connect to Functions emulator (may already be connected):', error);
  }
}

export default app;
